import React from 'react';
import { motion } from 'framer-motion';

const Problem = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }} 
        whileInView={{ opacity: 1, scale: 1 }} 
        viewport={{ once: true }} 
        className="glass-card p-10 md:p-16 relative"
      >
        <div className="absolute top-10 left-10 w-20 h-20 bg-red-500/10 blur-[40px] rounded-full" />
        <h2 className="text-4xl font-bold mb-8 text-white font-display text-center">
          Your Digital Presence Is Quietly Undermining Your Credibility
        </h2>
        <div className="space-y-6 text-lg text-slate-400 leading-relaxed">
          <p>
            For professional services and local businesses, your website is your <span className="text-white font-semibold">first consultation</span>. High-value clients judge your competence by your digital presence before they ever pick up the phone.
          </p>
          <p>
            Generic templates and amateur design choices cost you clients who value premium service. If your site looks like every other business in your market, you're competing on price, not authority.
          </p>
          <p className="text-blue-400 font-medium italic">
            "Clients don't buy services; they buy the confidence that you are the expert who can solve their problem."
          </p>
          <p>
            We replace generic "brochure" sites with high-performance authority engines and professional websites that establish trust instantly and rank locally when it matters most.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Problem;